import { ChangeDetectorRef, Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { finalize, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services/index';
import { ClampModel } from '../../../models/index';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { CalculationType } from '../../../enums/calculation-type.enum';

@Component({
    selector: 'app-clamp-size',
    templateUrl: './clamp-size.component.html',
    styleUrls: ['./clamp-size.component.scss'],
    standalone: false,
})
export class ClampSizeComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Output() selected: EventEmitter<ClampModel> = new EventEmitter();

    @Input()
    set manufacturerId(value: string) {
        if (value) {
            this._manufacturerId = value;
            if (!this.jointCalcService.isPipeCode) this.getClamps();
        }
    }
    get manufacturerId(): string {
        return this._manufacturerId;
    }
    destroy$ = new Subject();

    optionList: ClampModel[];
    tooltip_position = 'above';
    loading: boolean = false;
    private _manufacturerId: string;

    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private router: Router,
        private jointCalcService: JointCalcService
    ) {}

    ngOnInit(): void {
        this.form.markAllAsTouched();
        if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
            this.pipespecwithclampManufacturer();
        }
        this.form
            .get('clampSize')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode)
                        this.jointCalcService.selectedClampSize.next(value);
                }
            });
    }

    getClamps(): void {
        this.form.markAllAsTouched();
        if (!this.manufacturerId) return;
        this.loading = true;

        this.iceapi
            .getClamps(this.manufacturerId)
            .pipe(
                finalize(() => {
                    this.loading = false;
                    this.cd.detectChanges();
                })
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((clamps) => {
                if (clamps.success === true) {
                    this.optionList = clamps.response;
                    this.cd.markForCheck();
                    if (this.form.get('clampSize').value) {
                        this.dataService.selectedClampSize = this.optionList.find((x) => x.clampId === this.form.get('clampSize').value).name;
                    }
                    if (this.optionList.length === 1) this.form.get('clampSize').setValue(this.optionList[0].clampId);
                } else {
                    this.user_utility.errorModelPopup(clamps.message);
                }
            });
    }

    getClampNameSeries(clamp: ClampModel) {
        return [clamp.name, clamp.series].filter(Boolean).join(' - ');
    }

    selectClampSize(selectedValue: MatSelectChange): void {
        const selection = this.optionList.find((x) => x.clampId === selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
            this.dataService.selectedClampSize = selection.name;
        }
    }

    async pipespecwithclampManufacturer() {
        this.jointCalcService.selectedClampManufacturer.pipe(takeUntil(this.destroy$)).subscribe(async (cm) => {
            const inputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;

            inputGroup.recordId.pipeSizeId =
                inputGroup.recordId.boltMaterialId =
                inputGroup.recordId.clampMaterialId =
                inputGroup.recordId.pipeScheduleId =
                inputGroup.recordId.hubMaterialId =
                inputGroup.recordId.sealRingMaterialId =
                inputGroup.recordId.sealRingId =
                inputGroup.others.boltType =
                    null;

            if (cm && inputGroup.calculationType == CalculationType.Clamp) {
                this.loading = true;
                let i = 0;
                inputGroup.recordId.manufacturerId = cm;
                let pipeSpecClampManufacturer = await this.iceapi
                    .getClamps(cm)
                    .pipe(
                        finalize(() => {
                            this.loading = false;
                            this.cd.detectChanges();
                        })
                    )
                    .toPromise();

                if (pipeSpecClampManufacturer.success) {
                    this.optionList = pipeSpecClampManufacturer.response.slice();

                    if (this.dataService?.calculationData?.input?.recordId?.clampId)
                        this.form.get('clampSize').setValue(this.dataService?.calculationData?.input?.recordId?.clampId);
                    else if (this.optionList.length === 1) this.form.get('clampSize').setValue(this.optionList[0].clampId);
                } else if (pipeSpecClampManufacturer.isCustom) {
                    this.user_utility.errorModelPopup(pipeSpecClampManufacturer.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
